export default "__VITE_ASSET__6d0b14ad__"